var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isMobile
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "container-input",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.toggleOptions.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "input-header" }, [
                _c("div", { staticStyle: { width: "90%" } }, [
                  _c("div", { staticStyle: { "font-size": "14px" } }, [
                    _c("i", { staticClass: "fa-regular fa-user" }),
                    _vm._v("  \n            "),
                    _c("strong", [
                      _vm._v(
                        "QUANTIDADE DE " +
                          _vm._s(_vm.$props.nomeItem.toUpperCase())
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.optionsParsed.length <= 0
                      ? _c("i", [_vm._v("Nenhuma classificação disponível")])
                      : _c("span", { staticStyle: { color: "#757575" } }, [
                          _vm._v(_vm._s(_vm.resumo)),
                        ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "9%", "text-align": "right" } },
                  [
                    !_vm.opened
                      ? _c("i", {
                          staticClass: "fa-solid fa-angle-down",
                          style: { color: _vm.primaryColor },
                        })
                      : _c("i", {
                          staticClass: "fa-solid fa-angle-up",
                          style: { color: _vm.primaryColor },
                        }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.opened,
                      expression: "opened",
                    },
                  ],
                  staticClass: "input-body",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm._l(_vm.optionsParsed, function (option) {
                    return _c(
                      "div",
                      { key: option.id, staticClass: "faixa-option" },
                      [
                        _c("div", { staticClass: "faixa-option-info" }, [
                          _c("strong", [_vm._v(_vm._s(option.nome))]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("(" + _vm._s(option.descricao) + ")"),
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _vm.getCurrentPrice(option).precoDe
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "lightgray",
                                    "text-decoration": "line-through",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatMoney(
                                        _vm.getCurrentPrice(option).precoDe
                                      )
                                    ) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("strong", { style: { color: _vm.primaryColor } }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatMoney(
                                  _vm.getCurrentPrice(option).preco
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "faixa-option-quantity",
                            attrs: { translate: "no" },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-solid fa-minus",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.sub(option)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "faixa-option-quantity-display" },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.getCurrentQuantidade(option))
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa-solid fa-plus",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.add(option)
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      style: {
                        visibility: _vm.isDependentOnly ? "visible" : "hidden",
                      },
                    },
                    [
                      _c("small", [
                        _vm._v(
                          "É necessário adicionar ao menos 1 não dependente"
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.minVenda > 1 || _vm.maxVenda < Infinity
                    ? _c("div", { staticClass: "compliance-alert" }, [
                        _vm.minVenda > 1 && _vm.maxVenda < Infinity
                          ? _c("small", [
                              _vm._v(
                                "O máximo de vagas para a compra dessa atividade por pessoa é: " +
                                  _vm._s(_vm.maxVenda) +
                                  " (caso tenha disponibilidade). E no mínimo " +
                                  _vm._s(_vm.minVenda) +
                                  "."
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.minVenda <= 1 && _vm.maxVenda < Infinity
                          ? _c("small", [
                              _vm._v(
                                "O máximo de vagas para a compra dessa atividade por pessoa é: " +
                                  _vm._s(_vm.maxVenda) +
                                  " (caso tenha disponibilidade)."
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.minVenda > 1 && _vm.maxVenda >= Infinity
                          ? _c("small", [
                              _vm._v(
                                "O mínimo de vagas para a compra dessa atividade por pessoa é: " +
                                  _vm._s(_vm.minVenda) +
                                  " (caso tenha disponibilidade)."
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
        ])
      : _c(
          "div",
          [
            _c("div", [
              _vm.optionsParsed.length <= 0
                ? _c("i", [_vm._v("Nenhuma classificação disponível")])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm._l(_vm.optionsParsed, function (option, i) {
              return _c(
                "div",
                {
                  key: option.id,
                  staticClass: "faixa-mobile-option",
                  style: {
                    "border-bottom":
                      i >= _vm.optionsParsed.length - 1
                        ? "1px solid #CCCCCC"
                        : null,
                  },
                },
                [
                  _c("div", { staticClass: "faixa-mobile-option-info" }, [
                    _c("strong", [_vm._v(_vm._s(option.nome))]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [_vm._v("(" + _vm._s(option.descricao) + ")")]),
                    _c("br"),
                    _vm._v(" "),
                    _vm.getCurrentPrice(option).precoDe
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "lightgray",
                              "text-decoration": "line-through",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatMoney(
                                  _vm.getCurrentPrice(option).precoDe
                                )
                              ) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("strong", { style: { color: _vm.primaryColor } }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatMoney(_vm.getCurrentPrice(option).preco)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "faixa-mobile-option-quantity",
                      attrs: { translate: "no" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-solid fa-minus",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.sub(option)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "faixa-mobile-option-quantity-display" },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.getCurrentQuantidade(option))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa-solid fa-plus",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.add(option)
                          },
                        },
                      }),
                    ]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                style: {
                  visibility: _vm.isDependentOnly ? "visible" : "hidden",
                },
              },
              [
                _c("small", [
                  _vm._v("É necessário adicionar ao menos 1 não dependente"),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.minVenda > 1 || _vm.maxVenda < Infinity
              ? _c("div", { staticClass: "compliance-alert" }, [
                  _vm.minVenda > 1 && _vm.maxVenda < Infinity
                    ? _c("small", [
                        _vm._v(
                          "O máximo de vagas para a compra dessa atividade por pessoa é: " +
                            _vm._s(_vm.maxVenda) +
                            " (caso tenha disponibilidade). E no mínimo " +
                            _vm._s(_vm.minVenda) +
                            "."
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.minVenda <= 1 && _vm.maxVenda < Infinity
                    ? _c("small", [
                        _vm._v(
                          "O máximo de vagas para a compra dessa atividade por pessoa é: " +
                            _vm._s(_vm.maxVenda) +
                            " (caso tenha disponibilidade)."
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.minVenda > 1 && _vm.maxVenda >= Infinity
                    ? _c("small", [
                        _vm._v(
                          "O mínimo de vagas para a compra dessa atividade por pessoa é: " +
                            _vm._s(_vm.minVenda) +
                            " (caso tenha disponibilidade)."
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }